exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-510553a2]{z-index:333 !important}.flex-center[data-v-510553a2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.selWidth[data-v-510553a2]{width:320px}", ""]);

// exports
